import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { wishlistApi } from "../api/services";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const [wishlistCount, setWishlistCount] = useState(0);

  const refreshWishlist = useCallback(async () => {
    if (!isAuthenticated) {
      setWishlistCount(0);
      return 0;
    }
    try {
      const res = await wishlistApi.get();
      const count = res.data.data.wishlist?.items?.length || 0;
      setWishlistCount(count);
      return count;
    } catch {
      setWishlistCount(0);
      return 0;
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (authLoading) return;
    refreshWishlist();
  }, [authLoading, refreshWishlist]);

  const value = useMemo(
    () => ({
      wishlistCount,
      setWishlistCount,
      refreshWishlist,
    }),
    [wishlistCount, refreshWishlist]
  );

  return (
    <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>
  );
}

export function useWishlist() {
  const ctx = useContext(WishlistContext);
  if (!ctx) {
    throw new Error("useWishlist must be used within WishlistProvider");
  }
  return ctx;
}
